<template>
  <div class="footer-component">
    IMPRESSUM<br><br>

    Inhaltlich verantwortlich:<br>
    Dr Med János Szabó, Facharzt für Allgemeinmedizin<br><br>
    
    <div
      v-for="(praxis, i) in praxisData"
      :key="i"
    >
      {{ praxis.address }} {{ praxis.name }} {{ praxis.postcode }}
      <br>
      Tel.: {{ praxis.phone }}<br>
      Fax: {{ praxis.fax }}<br><br>
    </div>
    Berufsordnung für die Ärzte Niedersachsens:<br>
    Die Berufsordnung finden Sie auf der Website der Ärztekammer Niedersachsen:
    <a
      href="https://www.aekn.de/"
      target="_blank"
      style="color: white !important"
    >
      <u>
        https://www.aekn.de/
      </u>
    </a>
    <br><br>

    Zuständige KV:<br>
    Kassenärztliche Vereinigung Niedersachsen, Bezirkstelle Wilhelmshafen<br><br>

    Kammerzugehörigkeit:<br>
    Ärztekammer Niedersachsen, Berliner Allee 20 30175 Hannover<br><br>

    Arzt:<br>
    Dr Med János Szabó<br><br>

    Gesetzliche Berufsbezeichnung:<br>
    Facharzt für Allgemeinmedizin<br><br>

    Staat der Verleihung der Berufsbezeichnung:<br>
    Bundesrepublik Deutschland, Ungarn<br><br>

    Fotos: Horst Lohe, Orsolya Szabo<br><br>

    Trotz regelmäßiger inhaltlicher Kontrolle wird keine Haftung für Inhalte externer Links übernommen. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantworlich. Es gilt der über den nachfolgenden Link einsehbare Haftungsauschluss.<br><br>

    <a
      href="disclaimer.html"
      target="_blank"
      style="color: white !important"
    >
      <u>DATENSCHUTZERKLÄRUNGEN</u>
    </a><br><br>

    Webdesign by Zsuzsanna Seredi-Szabo & John Szabo © 2019-2023
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',

  props: {
    praxisData: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>
.footer-component {
  background-color: var(--primary);
  width: 100%;
  padding: 30px;
  color: white;
  font-size: 1rem;
}

@media screen and (max-width: 1100px) {
  .footer-component {
    font-size: 0.8rem;
  }
}
</style>